import Vuex from 'vuex'
import Vue from 'vue'
import auth from './modules/auth'
import access from './modules/access'
import global from './modules/global'

Vue.use(Vuex)

export default new Vuex.Store({    
    modules: { auth, access, global },
    strict: process.env.NODE_ENV !== 'production'
})
